/**
 * useWelcomeContent Hook
 *
 * Fetches welcome page content from church info.
 * Used for the redesigned /welcome landing page.
 */

import { useQuery } from "urql";

const WelcomeContentDocument = `
  query WelcomeContent {
    churchInfo {
      id
      mapUrl
      welcomeHeroVideoUrl
      welcomeHeroImageUrl
      welcomeHeroTitle
      welcomeHeroSubtitle
      welcomeAboutTitle
      welcomeAboutText
      welcomeDaysCount
      welcomeMissionText
    }
  }
`;

export interface WelcomeContent {
  id: string;
  mapUrl: string | null;
  welcomeHeroVideoUrl: string | null;
  welcomeHeroImageUrl: string | null;
  welcomeHeroTitle: string | null;
  welcomeHeroSubtitle: string | null;
  welcomeAboutTitle: string | null;
  welcomeAboutText: string | null;
  welcomeDaysCount: number | null;
  welcomeMissionText: string | null;
}

interface WelcomeContentQueryResult {
  churchInfo: WelcomeContent | null;
}

export function useWelcomeContent() {
  const [result, reexecute] = useQuery<WelcomeContentQueryResult>({
    query: WelcomeContentDocument,
  });

  const data = result.data?.churchInfo;

  return {
    heroVideoUrl: data?.welcomeHeroVideoUrl ?? null,
    heroImageUrl: data?.welcomeHeroImageUrl ?? null,
    heroTitle: data?.welcomeHeroTitle ?? "Добро пожаловать",
    heroSubtitle: data?.welcomeHeroSubtitle ?? "Первая русскоязычная Евангельская Церковь в Таиланде",
    aboutTitle: data?.welcomeAboutTitle ?? "Кто мы?",
    aboutText: data?.welcomeAboutText ?? null,
    daysCount: data?.welcomeDaysCount ?? 700,
    missionText: data?.welcomeMissionText ?? null,
    mapUrl: data?.mapUrl ?? null,
    isLoading: result.fetching,
    error: result.error,
    refetch: reexecute,
  };
}
